mmf_modules.define('api/tos',['require','exports','module','jquery'],function (require, exports, module) {

  var $ = require('jquery');

  exports.get = function (tosId) {
    return $.getJSON('/vxproxy/api/0.1/tos/' + tosId + '/');
  };

  exports.getLatest = function () {
    return $.getJSON('/vxproxy/api/0.1/tos/?latest=true&limit=1');
  };

  exports.getHTMLLink = function (tos) {
    try {
      return tos._embedded.tos[0]._links.tos_html[0].href;
    } catch (e) {
      return '';
    }
  };

  exports.getOverviewLink = function (tos) {
    try {
      return tos._embedded.tos[0]._links.overview_html[0].href;
    } catch (e) {
      return '';
    }
  };

});

